import * as z from "zod";

export const putShipmonkIntegration = {
  name: "putShipmonkIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    storeId: z.string().trim().min(1),
    sandboxMode: z.boolean(),
    allowBlindReturnsFallback: z.boolean(),
  }),
  output: z.object({}),
};
